'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useContext, useEffect } from 'react';

import cx from 'clsx';
import PropTypes from 'prop-types';

import ButtonCircle from 'components/ui/ButtonCircle';
import carouselContext from 'components/ui/CarouselProvider/CarouselContext';
import Text from 'components/ui/Text';

import styles from './OverflowCarouselNav.module.scss';

const OverflowCarouselNav = ({ isInView }) => {
    const context = useContext(carouselContext);

    useEffect(() => {
        const handleKeyUp = event => {
            switch (event.key) {
                case 'ArrowLeft':
                    context.prevSlide();
                    break;
                case 'ArrowRight':
                    context.nextSlide();
                    break;
                default:
                    break;
            }
        };

        if (isInView) {
            window.addEventListener('keyup', handleKeyUp);
        } else {
            window.removeEventListener('keyup', handleKeyUp);
        }

        return () => {
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, [context, isInView]);

    return (
        <div className={cx(styles.root)}>
            <ButtonCircle
                onClick={context.prevSlide}
                className={styles.navItem}
                theme="small-fill-blue"
                iconType="chevronLeft"
                tabIndex={isInView ? 0 : -1}
            >
                <span className="sr-only">Previous Slide</span>
            </ButtonCircle>
            <Text baseTheme="labelSmall" className={styles.navCount}>
                {`${(context.activeIndex ?? 0) + 1}/${context.totalSlides}`}
            </Text>
            <ButtonCircle
                onClick={context.nextSlide}
                className={styles.navItem}
                theme="small-fill-blue"
                iconType="chevronRight"
                tabIndex={isInView ? 0 : -1}
            >
                <span className="sr-only">Next Slide</span>
            </ButtonCircle>
        </div>
    );
};

OverflowCarouselNav.propTypes = {
    isInView: PropTypes.bool,
};

export default OverflowCarouselNav;
